/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientServicesDefault } from '../../models/client-services-default';

export interface GetDefaultServicesForCientIdGet$Json$Params {
  id: number;
}

export function getDefaultServicesForCientIdGet$Json(http: HttpClient, rootUrl: string, params: GetDefaultServicesForCientIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientServicesDefault>>> {
  const rb = new RequestBuilder(rootUrl, getDefaultServicesForCientIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientServicesDefault>>;
    })
  );
}

getDefaultServicesForCientIdGet$Json.PATH = '/GetDefaultServicesForCient/{id}';
